var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"height":"100%"}}),_c('bc-snackbar',{attrs:{"instance":_vm.snackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }